export const matchHeight = function(elem) {
    var height = 0;
    $(elem).each(function(){
        $(this).css('height','auto');
    });
    $(elem).each(function(){
        if($(this).height() > height){
            height = $(this).height();
        }
    });
    $(elem).each(function(){
        $(this).height(height);
    });
};
window.matchHeight = matchHeight;

export const showloading = function(elem){
    if(typeof elem !== 'undefined'){
        elem = elem;
    }else{
        elem = 'body';
    }
    $(elem).append('<div class="modal" data-backdrop="static" style="display:block; background-color: rgba(255,255,255,0.5);" tabindex="-1" role="dialog"><div class="modal-dialog modal-dialog-centered" role="document"><span class="spinner-border ml-auto mr-auto" style="width: 3rem; height: 3rem;" role="status" aria-hidden="true"></span></div></div>');
}
window.showloading = showloading;

export const getParameterByName = function(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
window.getParameterByName = getParameterByName;

export const tooltip = function(){
    if($('[data-toggle="tooltip"]').length){
        $('[data-toggle="tooltip"]').tooltip();
    }
}
window.tooltip = tooltip;
